import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ScheduleCardData } from './schedule-card.types';

@Component({
  selector: 'common-schedule-card',
  templateUrl: './schedule-card.component.html',
  styleUrls: ['./schedule-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleCardComponent {
  @Input() data: ScheduleCardData = {
    dayLabel: 'Lunes',
    slots: [{ fromLabel: 'Desde: 00:00 mm', toLabel: 'Hasta: 00:00 mm' }],
  };

  /** Texto cuando no hay franjas (evita layout roto). */
  @Input() emptyLabel = '—';
}
